/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import AddonProducts from '../../../../components/Web/Addons/redesign/AddonProducts';
import * as streamingDeviceActions from '../../actions';
import * as loaderActions from '../../../../components/common/Loader/action';
import * as cartActions from '../../../../services/Cart/actions';
import { getPlansData } from '../../../../utils/plansReference';
import * as Constants from '../../constants';
import { isWHWP2 } from '../../../../components/common/Helpers';

const mapStateToProps = (state) => {
  const addonsData = state.addons || {};
  const homePhoneService =
    addonsData && addonsData.landLineServices && addonsData.landLineServices.map((filteredItem) => ({ ...filteredItem, type: 'homePhoneService' }));
  const whwBasic = (addonsData && addonsData?.whwBasic) || {};
  const whwServicesWHWPLUS = addonsData?.whwServices && addonsData?.whwServices.length > 0 && addonsData?.whwServices.filter((obj) => obj?.skuDetails?.categoryType === 'WHWPLUS') || {};
  const whwServicesWHWBASIC = addonsData?.whwServices && addonsData?.whwServices.length > 0 && addonsData?.whwServices.filter((obj) => obj?.skuDetails?.categoryType === 'WHWBASIC') || {};
  const addvalueWHWPLUS = [whwServicesWHWBASIC?.[0], Constants?.DummyWHWPlus?.[0]?.whwServices?.[0]] || [];
  const addValueWHWBasic = [whwBasic, whwServicesWHWPLUS?.[0]] || [];
  const whwData = whwServicesWHWBASIC && whwServicesWHWBASIC.length > 0 ? [...addvalueWHWPLUS] : [...addValueWHWBasic];
  const vzProtectHome =
    addonsData && addonsData.featureServices && addonsData.featureServices.map((filteredItem) => ({ ...filteredItem, type: 'vzProtectHome' }));
  const tempWHWData = isWHWP2() && addonsData?.whwServices && addonsData?.whwServices.length === 0 && [whwBasic, Constants?.DummyWHWPlus?.[0]?.whwServices?.[0]];
  const whwServices = tempWHWData
    ? (tempWHWData && tempWHWData.map((object) => ({ ...object, type: 'whwServices' }))) || []
    :  addonsData?.whwServices?.length === 1 && (whwData && whwData.map((object) => ({ ...object, type: 'whwServices' }))) || []
  const whwServicesordering = (addonsData?.whwServices && addonsData?.whwServices.map((object) => ({ ...object, type: 'whwServices' }))) || [];
  const whwDetails = whwServicesordering && whwServicesordering.length > 1 ? [...whwServicesordering] : [...whwServices];
  const homeandVzDetails = vzProtectHome && homePhoneService && [...vzProtectHome, ...homePhoneService];
  const aemData = addonsData.addOnsFromAEM;
  const landline = aemData && aemData.landline;
  const getE911Address = addonsData && addonsData.fetchE911Address;
  const getNPANXX = addonsData && addonsData.getNPANXX;
  const plansReferenceData = getPlansData(state.plansReferenceData);
  const cartDetails = state.cartDetails ? state.cartDetails.cartDetailsJson : {};
  const isSkip = addonsData && addonsData.isSkip;
  const emergencyDetails = addonsData && addonsData.emergencyDetails;
  const validatee911Response = addonsData && addonsData.validatee911Response;
  const e911CallSuccess = addonsData && addonsData.e911CallSuccess;
  const isE911Call = addonsData && addonsData.isE911Call;
  const isDowngradeRedemption = addonsData && addonsData.isDowngradeRedemption;
  const showAddNotification = addonsData && addonsData.showAddNotification;
  const disableBtn = addonsData && addonsData.disableButton;
  const selectedProdID = addonsData && addonsData.selectedProdID;
  const selectedProdName = addonsData && addonsData.selectedProdName;
  const addonObj = addonsData && addonsData.addonObj && addonsData.addonObj.oddOnListArr;
  const savedZipCode = addonsData && addonsData.savedZipCode;
  const showCartApiError = state?.cartDetails?.showCartApiError;
  const addOnLoadingDone = state?.cartDetails?.loadingDone;
  const skipBtnCall = addonsData && addonsData.skipBtnCall;
  const selectedPlanInfo = addonsData && addonsData?.selectedPlanInfo?.selectedPlan;
  return {
    products: homeandVzDetails,
    aemContent: aemData,
    landline,
    savedZipCode,
    getE911Address,
    getNPANXX,
    plansReferenceData,
    cartDetails,
    isSkip,
    emergencyDetails,
    whwDetails,
    validatee911Response,
    e911CallSuccess,
    isE911Call,
    isDowngradeRedemption,
    showAddNotification,
    disableBtn,
    selectedProdID,
    selectedProdName,
    addonObj,
    showCartApiError,
    addOnLoadingDone,
    skipBtnCall,
    whwBasic,
    selectedPlanInfo,
  };
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...streamingDeviceActions, ...loaderActions, ...cartActions }, dispatch);
}
const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default withRouter(compose(withConnect)(AddonProducts));
